import {List, TextField, translate} from "react-admin";
import React from "react";
import CustomDatagrid from "../../../components/CustomDatagrid";

function RoutesList(props) {
    return (
        <>
            <List
                {...props}
                perPage={50}
            >
                <CustomDatagrid rowClick="show">
                    <TextField source="nameEs" label="Nombre (ES)"/>
                    <TextField source="nameEn" label="Nombre (EN)"/>
                    <TextField source="namePt" label="Nombre (PT)"/>
                    <TextField source="countriesFormatted" label={'Países'}/>
                    <TextField source="projects" label={'# Proyectos'}/>
                    <TextField style={{textAlign: 'right'}} source="totalInvestmentFormatted"
                               label={'Inversión total'}/>
                </CustomDatagrid>
            </List>
        </>
    );
}

export default translate(RoutesList);